import styled from 'styled-components';
import { colors } from 'Constants/Colors';

export const ModuleContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 1rem;
  flex-grow: 2;
`;

export const CollapsedLessonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3rem;
  width: auto;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ExpandedLessonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  gap: 3rem;
  margin: 0 auto;
`;

export const Title = {
  fontFamily: 'metropolis',
  fontSize: '1.2rem',
  color: colors.GRAY_DARKER,
  fontWeight: 'bold',
};

export const seeAllText = {
  position: 'absolute',
  fontFamily: 'metropolis',
  fontSize: '0.9rem',
  right: '0',
  cursor: 'pointer',
};

export default {
  ModuleContainer,
  CollapsedLessonContainer,
  ExpandedLessonContainer,
  Title,
  seeAllText,
};
